import script from "./ViewActionsTaken.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewActionsTaken.vue?vue&type=script&setup=true&lang=js"

import "./ViewActionsTaken.vue?vue&type=style&index=0&id=1653b80c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1653b80c"]])

export default __exports__